let lenis = null;
export const setLenis = (l) => {
  lenis = l;
};
export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.8 });
  else el.scrollIntoView({ behavior: "smooth" });
};
